module.exports = __webpack_public_path__ + "img/NewsIcon.c09a0c75.png";